<template>
    <form
        @submit.prevent="submitForm"
        v-if="! generatedCode"
    >
        <div class="grid grid-cols-3 gap-x-8 gap-y-6">
            <div>
                <label class="block mb-2 font-bold">Make</label>

                <Multiselect
                    v-model="statcode.makecode"
                    track-by="makecode"
                    label="name"
                    :options="makes"
                    :multiple="false"
                    :hide-selected="false"
                    :close-on-select="true"
                    :options-limit="99999999999"
                >
                </Multiselect>

                <div class="Form__error">{{ errors.makecode }}</div>
            </div>

            <div>
                <label class="block mb-2 font-bold">Model Code</label>

                <input
                    v-model.trim="statcode.modelcode"
                    type="text"
                    class="Form__text"
                    disabled
                >
                <div class="Form__error">{{ errors.modelcode }}</div>
            </div>

            <div>
                <label class="block mb-2 font-bold">Transmission</label>

                <Multiselect
                        v-model="statcode.manualauto"
                        track-by="code"
                        label="descript"
                        :options="transmissions"
                        :multiple="false"
                        :hide-selected="false"
                        :close-on-select="true"
                        :options-limit="99999999999"
                >
                </Multiselect>
                <div class="Form__error">{{ errors.manualauto }}</div>
            </div>

            <div>
                <label class="block mb-2 font-bold">Model Sequence</label>

                <input
                        v-model.trim="statcode.makeseq"
                        type="text"
                        class="Form__text"
                        disabled
                >
                <div class="Form__error">{{ errors.makeseq }}</div>
            </div>

            <div>
                <label class="block mb-2 font-bold">Range Sequence</label>

                <input
                        v-model.trim="statcode.rangeseq"
                        type="text"
                        class="Form__text"
                        disabled
                >
                <div class="Form__error">{{ errors.rangeseq }}</div>
            </div>

            <div>
                <label class="block mb-2 font-bold">Model Sequence</label>

                <input
                        v-model.trim="statcode.modelseq"
                        type="text"
                        class="Form__text"
                        disabled
                >
                <div class="Form__error">{{ errors.modelseq }}</div>
            </div>
        </div>

        <div class="grid grid-cols-3 gap-x-2 my-6 border-b-4 border-primary">
            <button
                type="button"
                class="border-0 text-white py-2 rounded-t-lg cursor-pointer"
                :class="{
                    'bg-primary': tab === 'all',
                    'bg-secondary': tab !== 'all',
                }"
                @click="tab = 'all'"
            >
                All Vehicles
            </button>

            <button
                type="button"
                class="border-0 text-white py-2 rounded-t-lg cursor-pointer"
                :class="{
                    'bg-primary': tab === 'hgv',
                    'bg-secondary': tab !== 'hgv',
                }"
                @click="tab = 'hgv'"
            >
                Heavy Goods Vehicles
            </button>

            <button
                type="button"
                class="border-0 text-white py-2 rounded-t-lg cursor-pointer"
                :class="{
                    'bg-primary': tab === 'pv',
                    'bg-secondary': tab !== 'pv',
                }"
                @click="tab = 'pv'"
            >
                Passenger Vehicles
            </button>
        </div>

        <div v-show="tab === 'all'">
            <div class="grid grid-cols-4 gap-x-8 gap-y-6">
                <div>
                    <label class="block mb-2 font-bold">Declaration No</label>

                    <input
                            v-model.trim="statcode.decno"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.decno }}</div>
                </div>

                <div class="col-span-3">
                    <label class="block mb-2 font-bold">Description</label>

                    <input
                            v-model.trim="statcode.descript"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.descript }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Vehicle Type</label>

                    <input
                            v-model.trim="statcode.vehictype"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.vehictype }}</div>
                </div>

                <div class="col-span-3">
                    <label class="block mb-2 font-bold">Comments</label>

                    <input
                            v-model.trim="statcode.comments"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.comments }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Related Declaration Number</label>

                    <input
                            v-model.trim="statcode.reldecno"
                            type="text"
                            class="Form__text"
                            disabled
                    >
                    <div class="Form__error">{{ errors.reldecno }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">OMSP</label>

                    <input
                            v-model.trim="statcode.omsp"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.omsp }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Range</label>

                    <Multiselect
                            v-model="statcode.range"
                            label="descript"
                            :options="ranges"
                            :multiple="false"
                            :hide-selected="false"
                            :close-on-select="true"
                            :options-limit="99999999999"
                    >
                    </Multiselect>
                    <div class="Form__error">{{ errors.range }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Body Type</label>

                    <Multiselect
                            v-model="statcode.bodytype"
                            label="descript"
                            :options="bodyTypes"
                            :multiple="false"
                            :hide-selected="false"
                            :close-on-select="true"
                            :options-limit="99999999999"
                    >
                    </Multiselect>
                    <div class="Form__error">{{ errors.bodytype }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">RRSP</label>

                    <input
                            v-model.trim="statcode.rrsp"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.rrsp }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Net Power</label>

                    <input
                            v-model.trim="statcode.netpower"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.netpower }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Engine Capacity</label>

                    <input
                            v-model.trim="statcode.enginecap"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.enginecap }}</div>
                </div>

                <div>
<!--                    <label class="block mb-2 font-bold">OMSP as % of RRSP</label>-->

<!--                    <input-->
<!--                            v-model.trim="statcode.omsprrsp"-->
<!--                            type="text"-->
<!--                            class="Form__text"-->
<!--                    >-->
<!--                    <div class="Form__error">{{ errors.omsprrsp }}</div>-->
                </div>

                <div>
                    <label class="block mb-2 font-bold">Vehicle Length</label>

                    <input
                            v-model.trim="statcode.lengthveh"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.lengthveh }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Wheelbase</label>

                    <input
                            v-model.trim="statcode.wheelbase"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.wheelbase }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Engine Type</label>

                    <Multiselect
                            v-model="statcode.engtype"
                            track-by="code"
                            label="fulldescr"
                            :options="engineTypes"
                            :multiple="false"
                            :hide-selected="false"
                            :close-on-select="true"
                            :options-limit="99999999999"
                    >
                    </Multiselect>
                    <div class="Form__error">{{ errors.engtype }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Diff in OMSP</label>

                    <input
                            v-model.trim="statcode.diffomsp"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.diffomsp }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Vehicle Width</label>

                    <input
                            v-model.trim="statcode.widthveh"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.widthveh }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Seats</label>

                    <input
                            v-model.trim="statcode.seats"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.seats }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">GVW</label>

                    <input
                            v-model.trim="statcode.gvw"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.gvw }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Unladen Weight</label>

                    <input
                            v-model.trim="statcode.unladewght"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.unladewght }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Windows</label>

                    <input
                            v-model.trim="statcode.windows"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.windows }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Doors</label>

                    <input
                            v-model.trim="statcode.nodoors"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.nodoors }}</div>
                </div>
            </div>
        </div>

        <div v-show="tab === 'hgv'">
            <div class="grid grid-cols-4 gap-x-8 gap-y-6">
                <div>
                    <label class="block mb-2 font-bold">EU Vehicle Category</label>

                    <input
                            v-model.trim="statcode.euvehcat"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.euvehcat }}</div>
                </div>

                <div class="col-span-3"></div>

                <div>
                    <label class="block mb-2 font-bold">Type Approval Directive M1</label>

                    <input
                            v-model.trim="statcode.tyapdirm1"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.tyapdirm1 }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">No Axles</label>

                    <input
                            v-model.trim="statcode.axles"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.axles }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Axel Weight 1</label>

                    <input
                            v-model.trim="statcode.axlew1"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.axlew1 }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Type Approval Directive Non-M1</label>

                    <input
                            v-model.trim="statcode.tyapdirnm1"
                            type="text"
                            class="Form__text"
                            disabled
                    >
                    <div class="Form__error">{{ errors.tyapdirnm1 }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Axel Weight 2</label>

                    <input
                            v-model.trim="statcode.axlew2"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.axlew2 }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Trailer Braked</label>

                    <input
                            v-model.trim="statcode.trailerb"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.trailerb }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">GCW</label>

                    <input
                            v-model.trim="statcode.gcw"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.gcw }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Axel Weight 3</label>

                    <input
                            v-model.trim="statcode.axlew3"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.axlew3 }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Trailer Unbraked</label>

                    <input
                            v-model.trim="statcode.trailerub"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.trailerub }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Axel Weight 4</label>

                    <input
                            v-model.trim="statcode.axlew4"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.axlew4 }}</div>
                </div>

                <div></div>

                <div>
                    <label class="block mb-2 font-bold">Cargo Area Length</label>

                    <input
                            v-model.trim="statcode.cargoareal"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.cargoareal }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Mass in Service</label>

                    <input
                            v-model.trim="statcode.massis"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.massis }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Axel Weight 5</label>

                    <input
                            v-model.trim="statcode.axlew5"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.axlew5 }}</div>
                </div>

                <div></div>


                <div>
                    <label class="block mb-2 font-bold">Type Approval Number</label>

                    <input
                            v-model.trim="statcode.typeapno"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.typeapno }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Standing</label>

                    <input
                            v-model.trim="statcode.standing"
                            type="text"
                            class="Form__text"
                            disabled
                    >
                    <div class="Form__error">{{ errors.standing }}</div>
                </div>

                <div class="col-span-2"></div>

                <div>
                    <label class="block mb-2 font-bold">Power Weight Ratio</label>

                    <input
                            v-model.trim="statcode.powerweigh"
                            type="text"
                            class="Form__text"
                            disabled
                    >
                    <div class="Form__error">{{ errors.powerweigh }}</div>
                </div>

                <div>
                    <label class="block mb-2 font-bold">Drive Type</label>

                    <input
                            v-model.trim="statcode.drvtype"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.drvtype }}</div>
                </div>
            </div>
        </div>

        <div v-show="tab === 'pv'">
            <div class="grid grid-cols-2 gap-x-8 gap-y-6">
<!--                <div>-->
<!--                    <label class="block mb-2 font-bold">CO2 Emissions</label>-->

<!--                    <input-->
<!--                            v-model.trim="statcode.co2"-->
<!--                            type="text"-->
<!--                            class="Form__text"-->
<!--                    >-->
<!--                    <div class="Form__error">{{ errors.co2 }}</div>-->
<!--                </div>-->

                <div>
                    <label class="block mb-2 font-bold">WLTPCO2OR</label>

                    <input
                            v-model.trim="statcode.wltpco2or"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.wltpco2or }}</div>
                </div>

<!--                <div>-->
<!--                    <label class="block mb-2 font-bold">Urban Consumption Litre Per 100km</label>-->

<!--                    <input-->
<!--                            v-model.trim="statcode.urban"-->
<!--                            type="text"-->
<!--                            class="Form__text"-->
<!--                    >-->
<!--                    <div class="Form__error">{{ errors.urban }}</div>-->
<!--                </div>-->

                <div>
                    <label class="block mb-2 font-bold">NOXEMMISIONSOR</label>

                    <input
                            v-model.trim="statcode.noxemmisionsor"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.noxemmisionsor }}</div>
                </div>

<!--                <div>-->
<!--                    <label class="block mb-2 font-bold">Extra Urban Consumption Litre Per 100km</label>-->

<!--                    <input-->
<!--                            v-model.trim="statcode.extraurban"-->
<!--                            type="text"-->
<!--                            class="Form__text"-->
<!--                    >-->
<!--                    <div class="Form__error">{{ errors.extraurban }}</div>-->
<!--                </div>-->

                <div>
                    <label class="block mb-2 font-bold">NOXEMMISIONS</label>

                    <input
                            v-model.trim="statcode.noxemmisions"
                            type="text"
                            class="Form__text"
                    >
                    <div class="Form__error">{{ errors.noxemmisions }}</div>
                </div>

            </div>
        </div>

        <input type="submit"
               value="Create"
               class="Button mt-6"
        >
    </form>

    <table
        class="Table"
        v-else
    >
        <tr>
            <th class="text-left">
                Declaration No.
            </th>

            <th class="text-left">
                Statcode
            </th>

            <th class="text-left">
                Message
            </th>
        </tr>

        <tr v-for="code in generatedCode">
            <td v-html="code.decno">
            </td>

            <td v-html="code.statcode">
            </td>

            <td v-html="code.message">
            </td>
        </tr>
    </table>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        data() {
            return {
                statcode: {
                    makecode: '',
                    modelcode: '0000',
                    manualauto: '',
                    decno: '',
                    engtype: '',
                    bodytype: '',
                    descript: '',
                    range: '',
                    nodoors: '',
                    lengthveh: '0',
                    widthveh: '0',
                    makeseq: '',
                    rangeseq: '',
                    modelseq: '',
                    vehictype: '',
                    comments: '',
                    reldecno: '',
                    omsp: '',
                    rangeid: '',
                    rrsp: '',
                    netpower: '',
                    enginecap: '',
                    omsprrsp: '',
                    wheelbase: '',
                    diffomsp: '',
                    seats: '',
                    gvw: '',
                    unladewght: '',
                    windows: '',
                    euvehcat: '',
                    tyapdirm1: '',
                    axles: '',
                    axlew1: '',
                    axlew2: '',
                    axlew3: '',
                    axlew4: '',
                    axlew5: '',
                    tyapdirnm1: '',
                    trailerb: '',
                    gcw: '',
                    trailerub: '',
                    cargoareal: '',
                    massis: '',
                    typeapno: '',
                    standing: '',
                    powerweigh: '',
                    drvtype: '',
                    co2: 0,
                    wltpco2or: 0,
                    urban: 0,
                    noxemmisionsor: 0,
                    extraurban: 0,
                    noxemmisions: 0,
                    combined: 0,
                },

                errors: {
                    makecode: '',
                    modelcode: '',
                    manualauto: '',
                    decno: '',
                    engtype: '',
                    bodytype: '',
                    descript: '',
                    range: '',
                    nodoors: '',
                    lengthveh: '',
                    widthveh: '',
                    makeseq: '',
                    rangeseq: '',
                    modelseq: '',
                    vehictype: '',
                    comments: '',
                    reldecno: '',
                    omsp: '',
                    rangeid: '',
                    rrsp: '',
                    netpower: '',
                    enginecap: '',
                    omsprrsp: '',
                    wheelbase: '',
                    diffomsp: '',
                    seats: '',
                    gvw: '',
                    unladewght: '',
                    windows: '',
                    euvehcat: '',
                    tyapdirm1: '',
                    axles: '',
                    axlew1: '',
                    axlew2: '',
                    axlew3: '',
                    axlew4: '',
                    axlew5: '',
                    tyapdirnm1: '',
                    trailerb: '',
                    gcw: '',
                    trailerub: '',
                    cargoareal: '',
                    massis: '',
                    typeapno: '',
                    standing: '',
                    powerweigh: '',
                    drvtype: '',
                    co2: '',
                    wltpco2or: '',
                    urban: '',
                    noxemmisionsor: '',
                    extraurban: '',
                    noxemmisions: '',
                    combined: '',
                },

                tab: 'all',

                ranges: [],

                generatedCode: null,

                submitting: false,
            }
        },

        props: {
            makes: {
                type: Array,
            },

            transmissions: {
                type: Array,
            },

            bodyTypes: {
                type: Array,
            },

            engineTypes: {
                type: Array,
            },
        },

        components: { Multiselect },

        watch: {
            'statcode.makecode': function (makecode) {
                this.statcode.rangeid = '';

                axios.post('/statcodes/ranges', {
                    makecode: makecode
                }).then(response => {
                    this.ranges = response.data;
                })
            },

            'statcode.range': function (range) {
                this.statcode.makeseq = range.makeseq;
                this.statcode.rangeseq = range.rangeseq;
            }
        },

        methods: {
            submitForm() {
                if (this.submitting) return false;

                this.submitting = true;

                axios.post('statcodes/form', this.statcode)
                    .then(response => {
                        this.generatedCode = response.data;
                        this.submitting = false;
                    }).catch(error => {
                        this.errors = {};

                        _.each(error.response.data.errors, (errors, key) => {
                            this.errors[key] = errors[0];
                        });

                        this.submitting = false;
                })
            }
        }
    }
</script>

<style>
    .grid {
        display: grid
    }

    .block {
        display: block;
    }

    .grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .col-span-2 {
        grid-column: span 2 / span 2;
    }

    .col-span-3 {
        grid-column: span 3 / span 3;
    }

    .gap-x-2 {
        column-gap: 0.5rem;
    }

    .gap-x-8 {
        column-gap: 2rem;
    }

    .gap-y-6 {
        row-gap: 1.5rem;
    }

    .mb-2 {
        margin-bottom: 0.5rem;
    }

    .mt-6 {
        margin-top: 1.5rem;
    }

    .my-6 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }

    .py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .border-0 {
        border: none;
    }

    .font-bold {
        font-weight: bold;
    }

    .bg-primary {
        background: #005daa;
    }

    .bg-secondary {
        background: #0099ff;
    }

    .text-white {
        color: white;
    }

    .rounded-t-lg {
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .border-b-4 {
        border-bottom: 4px;
        border-bottom-style: solid;
    }

    .border-primary {
        border-bottom-color: #005daa;
    }

    .border-secondary {
        border-bottom-color: #0099ff;
    }
</style>